import { createApp } from "vue";
import ArtistSearch from "./ArtistsSearch.vue";
import { createSearchStore } from "@/domain/search/SearchStore";
import { ApiPlugin } from "../../plugins/api.plugin";
import { ApiService } from "../../../../modules/api/api.service";
import { TranslationPlugin } from "../../plugins/translation.plugin";
import { TranslationService } from "webshop-modules/translation/translation.service";
import { vue3Debounce } from "vue-debounce";

const artistSearchInstance = createApp(ArtistSearch);

const apiConfiguration = ApiService.getInjectedConfiguration(document, 'artists-search.js');

artistSearchInstance.use(new ApiPlugin(apiConfiguration));
artistSearchInstance.use(new TranslationPlugin(TranslationService.getConfiguration(document, 'artists-search.js')));

artistSearchInstance.directive('debounce', vue3Debounce({ listenTo: 'input', lock: true, defaultTime: "30000ms" }));

artistSearchInstance.use(createSearchStore(apiConfiguration));

artistSearchInstance.mount("#artists-search");

